import { SELECT_SME_PROFILE } from "../../actions/types/account.types";
import {
    FETCH_PAYROLL_SUCCEEDED,
    PAYROLL_CONFIRM_CONSENT_SUCCEEDED,
    UPDATE_CONSENT_DATA,
} from "./types";

const initialState = {
    initialLoadingState: "loading",
    payroll: [],
    consent: null,
};

const payrollReducer = (state = initialState, action) => {
    switch (action?.type) {
        case SELECT_SME_PROFILE:
            return {
                ...initialState,
            };
        case FETCH_PAYROLL_SUCCEEDED:
            return {
                ...state,
                payroll: [...action.payload.data],
            };

        case UPDATE_CONSENT_DATA:
        case PAYROLL_CONFIRM_CONSENT_SUCCEEDED:
            const { data, message } = action.payload;
            const consent = !data ? message : data;

            return {
                ...state,
                initialLoadingState: "loaded",
                consent,
            };

        default:
            return state;
    }
};

export default payrollReducer;
